<template>
  <div class="scheme-config">
    <el-tabs v-model="activeTab" @tab-click="handleTabClick">
      <el-tab-pane label="保额*费率" name="coverage_rate">
        <CoverageRate />
      </el-tab-pane>
      <el-tab-pane label="固定保额" name="fixed_coverage">
        <FixedCoverage />
      </el-tab-pane>
      <el-tab-pane label="固定保额+类别" name="fixed_coverage_type">
        <FixedCoverageType />
      </el-tab-pane>
      <el-tab-pane label="运费*费率" name="freight_rate">
        <FreightRate />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import CoverageRate from './components/CoverageRate'
import FixedCoverage from './components/FixedCoverage'
import FixedCoverageType from './components/FixedCoverageType'
import FreightRate from './components/FreightRate'

export default {
  name: 'SchemeConfig',
  components: {
    CoverageRate,
    FixedCoverage,
    FixedCoverageType,
    FreightRate
  },
  data() {
    return {
      activeTab: 'coverage_rate'
    }
  },
  methods: {
    handleTabClick(tab) {
      console.log('切换到标签页:', tab.name)
    }
  }
}
</script>

<style scoped>
.scheme-config {
  padding: 20px;
  height: calc(100vh - 120px);
}

/* 确保标签页内容区域充满容器 */
.el-tabs {
  height: 100%;
}

.el-tab-pane {
  height: calc(100vh - 200px);
  overflow: auto;
}

/* 修复标签页内容区的高度问题 */
:deep(.el-tabs__content) {
  height: calc(100% - 55px);
}

:deep(.el-tab-pane) {
  height: 100%;
}
</style>